import VueI18n from 'vue-i18n-legacy'
import { useI18n as useI18nLib } from 'vue-i18n'

import fr_default from './default/fr-FR.json'

let i18n: VueI18n

export function provideVue18n(val: VueI18n) {
  i18n = val
}

export function useI18nForVue2(): VueI18n {
  if (!i18n) {
    throw new Error('i18n was not initialized')
  }
  return i18n
}

type MessageSchema = typeof fr_default

export function useI18n() {
  return useI18nLib<[MessageSchema]>()
}
